// extracted by mini-css-extract-plugin
module.exports = {"root":"loading_root__2DcqG"};